import {
  LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_BASIC_BUTTON,
  LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_PRO_BUTTON,
  LOYALTY_SUBSCRIPTION_FEATURE_PRICE,
  LOYALTY_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS,
  LOYALTY_SUBSCRIPTION_PAGE_ON_LOADING,
  LOYALTY_SUBSCRIPTION_GET_BILLINGS,
  LOYALTY_SUBSCRIPTION_GET_OUTLETS,
  LOYALTY_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL,
  LOYALTY_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  LOYALTY_SUBSCRIPTION_LOAD,
  LOYALTY_SUBSCRIPTION_PAGE_REQUEST,
  LOYALTY_SUBSCRIPTION_SET_BUTTON_MESSAGE,
  LOYALTY_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
  LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE,
  LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
  LOYALTY_SUBSCRIPTION_SET_OUTLETS,
  LOYALTY_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
  LOYALTY_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
  LOYALTY_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
  LOYALTY_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL,
  LOYALTY_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  LOYALTY_SUBSCRIPTION_START_PRO_TRIAL,
  LOYALTY_SUBSCRIPTION_SUBSCRIPTION_STATUS,
  LOYALTY_SUBSCRIPTION_SUBSCRIBE_BASIC,
  LOYALTY_SUBSCRIPTION_SUBSCRIBE_PRO,
} from './constant';

// Default dispatch
export function loadLoyaltySubscription(billingNotification) {
  return {
    type: LOYALTY_SUBSCRIPTION_LOAD,
    payload: { billingNotification },
  };
}

export function subscriptionPageRequest(
  trialEndAt,
  outletSlot,
  alreadySubscribed
) {
  return {
    type: LOYALTY_SUBSCRIPTION_PAGE_REQUEST,
    payload: { trialEndAt, outletSlot, alreadySubscribed },
  };
}

export function featurePricePerMonths(featureNames) {
  return {
    type: LOYALTY_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS,
    payload: featureNames,
  };
}

export function featurePrice(trialEndAt, outletSlot, alreadySubscribed) {
  return {
    type: LOYALTY_SUBSCRIPTION_FEATURE_PRICE,
    payload: { trialEndAt, outletSlot, alreadySubscribed },
  };
}

export function setFeaturePricePerMonths(featurePricePerMonths) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
    payload: { featurePricePerMonths },
  };
}

export function setFeaturePrice(featureName, featurePrice) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE,
    payload: { featureName, featurePrice },
  };
}

export function subscriptionStatus(featureNames) {
  return {
    type: LOYALTY_SUBSCRIPTION_SUBSCRIPTION_STATUS,
    payload: featureNames,
  };
}

export function setPageOnLoading(pageOnLoading) {
  return {
    type: LOYALTY_SUBSCRIPTION_PAGE_ON_LOADING,
    payload: { pageOnLoading },
  };
}

export function startProTrial() {
  return {
    type: LOYALTY_SUBSCRIPTION_START_PRO_TRIAL,
  };
}

export function subscribeBasic() {
  return {
    type: LOYALTY_SUBSCRIPTION_SUBSCRIBE_BASIC,
  };
}

export function subscribePro(billingData) {
  return {
    type: LOYALTY_SUBSCRIPTION_SUBSCRIBE_PRO,
    payload: { billingData },
  };
}

export function setPendingPaymentMessage(pendingPaymentMessage) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
    payload: { pendingPaymentMessage },
  };
}

export function setPendingOutletMessage(pendingOutletMessage) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
    payload: { pendingOutletMessage },
  };
}

export function setSubscriptionDetail(subscriptionDetail) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
    payload: { subscriptionDetail },
  };
}

export function setCurrentOutletCount(currentOutletCount) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
    payload: { currentOutletCount },
  };
}

export function setOutlets(outlets) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_OUTLETS,
    payload: { outlets },
  };
}

export function setPayButtonMessage(buttonMessage) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_BUTTON_MESSAGE,
    payload: { buttonMessage },
  };
}

export function getBillings() {
  return {
    type: LOYALTY_SUBSCRIPTION_GET_BILLINGS,
  };
}

export function getOutlets() {
  return {
    type: LOYALTY_SUBSCRIPTION_GET_OUTLETS,
  };
}

export function setSubscribeBasicButton(isSubscribeBasicButtonEnabled) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_BASIC_BUTTON,
    payload: { isSubscribeBasicButtonEnabled },
  };
}

export function setSubscribeProButton(isSubscribeProButtonEnabled) {
  return {
    type: LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_PRO_BUTTON,
    payload: { isSubscribeProButtonEnabled },
  };
}

export function showDetailTransactionModal() {
  return {
    type: LOYALTY_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL,
  };
}

export function hideDetailTransactionModal() {
  return {
    type: LOYALTY_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL,
  };
}

export function showPaymentGatewayErrorModal() {
  return {
    type: LOYALTY_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  };
}

export function hidePaymentGatewayErrorModal() {
  return {
    type: LOYALTY_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  };
}
